<template>
  <section class="bg-gray-50 py-20 px-4">
    <div class="max-w-6xl mx-auto text-center">
      <h2 class="text-3xl md:text-4xl font-bold text-[#924f19] mb-12">
        Best Dental Clinic in Guwahati – Why Patients Trust Magnum Dental
      </h2>

      <div class="grid gap-10 md:grid-cols-2 text-left">
        <div
          v-for="(item, index) in reasons"
          :key="index"
          class="bg-white rounded-xl shadow hover:shadow-md transition overflow-hidden"
        >
          <!-- Image -->
          <div class="aspect-[16/9] w-full">
            <img
              :src="item.image"
              :alt="item.title"
              loading="lazy"
              class="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="mt-16 max-w-4xl mx-auto">
  <div class="bg-white rounded-3xl px-8 py-10 text-center shadow-sm">
    <p class="text-lg md:text-xl font-semibold text-[#924f19] mb-4">
      Our Promise to Every Patient
    </p>

    <p class="text-gray-600 leading-relaxed text-base md:text-lg">
      At <span class="font-semibold text-gray-800">Magnum Dental</span>, we are committed
      to delivering exceptional dental care with a perfect blend of expertise,
      advanced technology, and a patient-first approach. Recognized as a trusted
      dental clinic in Guwahati, we focus on comfort, safety, and long-lasting
      results — so every visit feels reassuring, transparent, and personalized.
    </p>
  </div>
</div>

</template>

<script>
export default {
  name: "WhyPatientsLoveUs",
  data() {
    return {
      reasons: [
        {
          title: "Expert Care",
          image: "Experts.png",
          description:
            "Highly experienced dentists delivering safe, precise, and reliable treatments you can trust.",
        },
        {
          title: "Sterilisation",
          image: "Sterilisation.png",
          description:
            "Strict sterilization protocols ensuring the highest standards of hygiene and patient safety.",
        },
        {
          title: "Advanced Technology",
          image: "Advanced.png",
          description:
            "Modern equipment and digital dentistry for accurate diagnosis and efficient treatment.",
        },
        {
          title: "Personalised Approach",
          image: "Personalised.png",
          description:
            "Tailored treatment plans designed around your needs, comfort, and long-term dental health.",
        },
        {
          title: "Calm & Comfortable",
          image: "Calm.png",
          description:
            "A soothing clinic environment designed to help you feel relaxed throughout your visit.",
        },
        {
          title: "Comprehensive Care",
          image: "Complete.png",
          description:
            "Complete dental solutions under one roof — from prevention to advanced procedures.",
        },
      ],
    };
  },
};
</script>
